<template>
    <RecaptchaV2
        :sitekey="`${runTimeConfig.public.recaptchaSiteKey}`"
        @widget-id="handleWidgetId"
        @error-callback="handleErrorCallback"
        @expired-callback="handleExpiredCallback"
        @load-callback="handleLoadCallback"
    />
</template>
<script setup lang="ts">
import { RecaptchaV2, useRecaptcha } from 'vue3-recaptcha-v2';

const emit = defineEmits(['recaptcha-verified', 'update-failed-attempt', 'update-reset-function']);

const props = defineProps({
    resetState: {
        type: Boolean,
    }
});

const runTimeConfig = useRuntimeConfig();
const { handleReset } = useRecaptcha();
const isRecaptchaVerified = ref(true);

const widget_Id = ref(0)

const handleWidgetId = (widgetId: number) => {
    // Met à jour l'identifiant du widget reCAPTCHA
    widget_Id.value = widgetId;
};
const handleErrorCallback = () => {
    // Action à effectuer en cas d'erreur du reCAPTCHA
};
const handleExpiredCallback = () => {
    // Action à effectuer lorsque le reCAPTCHA expire
    isRecaptchaVerified.value = false;
    emit('recaptcha-verified', isRecaptchaVerified.value,);;
};
const handleLoadCallback = () => {
    // Action effectuée après vérification du reCAPTCHA
    emit('update-failed-attempt', 4);
    isRecaptchaVerified.value = true;
    emit('recaptcha-verified', isRecaptchaVerified.value);
    
};

watch(
    () => props.resetState,
    (newValue) => {
        if (newValue) {
            handleReset(widget_Id.value);
            emit('update-reset-function', false);
        }
    }
);

</script>
